// ArChat Auto-Normalized File
// Created: 12-03-2026 22:38:36
// Author: SIVOL® - Aldo Frias - Argentina

import { plansTranslationsEn } from './plansTranslations.en.js';
export const plansTranslationsZh = {
  ...plansTranslationsEn,
  'plans.founder.remaining': '剩余 {count} 个 Founder 名额',
  'plans.founder.remaining_last': '最后 {count} 个 Founder 名额',
  'plans.founder.remaining_limited': '名额有限：剩余 {count}',
  'plans.founder.remaining_very_low': '仅剩 {count} 个 Founder 名额',
  'plans.founder.soldout': 'Founder 已售罄',
  'plans.foundation.best_value': '',
  'plans.foundation.savings': '',
  'plans.compare.pro.adjustment_notice': '价格可能会根据服务条件进行调整。',
  'plans.compare.title': 'Choose your plan',
  'plans.compare.free.title': 'FREE',
  'plans.compare.foundation.title': 'FOUNDATION ⭐',
  'plans.compare.pro.title': 'PRO',
  'plans.compare.foundation.badge': '150 limited slots',
  'plans.compare.cta.foundation': 'Become a Founder',
  'plans.compare.cta.pro': 'Upgrade to PRO',
  'plans.compare.active': 'Current plan',
  'plans.compare.limited': '',
  'plans.limit.title.messages': 'Message limit reached',
  'plans.limit.message.messages': 'You reached your message limit. Upgrade to FOUNDATION or PRO.',
  'plans.limit.title.storage': 'Storage limit reached',
  'plans.limit.message.storage': 'You reached your storage limit. Upgrade to upload more files.',
  'plans.limit.title.invitations': 'Invitation limit reached',
  'plans.limit.message.invitations': 'You reached your invitation limit. Upgrade to invite more.',
  'plans.limit.reached': 'Limit reached — Upgrade plan',
  'plans.compare.institucional.title': 'Title',
  'plans.compare.yourPlan': 'YourPlan',
  'plans.modal.title': '升级计划',
  'plans.modal.comparison_title': '计划对比',
  'plans.modal.billing_period': '',
  'plans.modal.price_note': '',
  'plans.modal.free.line1': '每个账户每月 30,000 个字符。',
  'plans.modal.free.line2': '每位用户最多 2 个联系人。',
  'plans.modal.free.line3': '每个账户最多 2 个活跃会话。',
  'plans.modal.free.line4': '无附件或存储空间。',
  'plans.modal.free.line5': '无数据导出。',
  'plans.modal.free.line6': '消息记录最长 30 天。',
  'plans.modal.free.line7': '每位用户仅 1 台设备。',
  'plans.modal.premium.line1': '每个账户每月 300,000 个字符。',
  'plans.modal.premium.line2': '每位用户最多 100 个联系人。',
  'plans.modal.premium.line3': '无限会话与聊天（租户）。',
  'plans.modal.premium.line4': '最多 50 MB 存储（租户）。',
  'plans.modal.premium.line5': '每位用户最多 3 台设备。',
  'plans.modal.premium.line6': '无限邀请（租户）。',
  'plans.modal.premium.line7': '包含在方案限制内的导出、自动翻译与文件。',
  'plans.modal.premium_block_heading': '引擎使用限制（高级）',
  'plans.modal.foundation.ribbon': 'Founder Access',
  'plans.modal.foundation.program_title': 'Founder 计划',
  'plans.modal.foundation.categories_title': 'Founder 类别（{slots} 个名额）',
  'plans.modal.foundation.cat_legendary_title': 'LEGENDARY Founder',
  'plans.modal.foundation.cat_legendary_range': '位置 1–25',
  'plans.modal.foundation.cat_legendary_desc': '最早支持项目的人。最高的历史优先级。',
  'plans.modal.foundation.cat_early_title': 'EARLY Founder',
  'plans.modal.foundation.cat_early_range': '位置 26–75',
  'plans.modal.foundation.cat_early_desc': '早期支持并获得特别认可。',
  'plans.modal.foundation.cat_std_title': 'Founder',
  'plans.modal.foundation.cat_std_range': '位置 76–150',
  'plans.modal.foundation.cat_std_desc': '150 个名额内的 Founder 席位。',
  'plans.modal.foundation.advantages_title': 'Founder 优势',
  'plans.modal.foundation.adv1': '访问有限的 Founder 池（{slots} 个编号席位）。',
  'plans.modal.foundation.adv2': '作为 ArChat 创始用户的认可。',
  'plans.modal.foundation.adv3': '产品体验中的 Founder 徽章与存在感。',
  'plans.modal.foundation.adv4': '根据您的位置（1–150）获得历史优先级与地位。',
  'plans.modal.foundation.adv5': '在现行政策适用期间，与 Founder 访问绑定的持续权益。',
  'plans.modal.pro.tagline': '标准高级版 — 不含 Founder 组件',
  'plans.badges.foundation': 'Founder',
  'plans.free.title': 'FREE',
  'plans.free.subtitle': '免费计划',
  'plans.free.features.contacts': '每位用户最多 2 个联系人',
  'plans.free.features.conversations': '每个账户最多 2 个活跃会话',
  'plans.free.features.no_export': '每账户每月 3 万字符；34 条/天、1000 条/月；无导出',
  'plans.free.features.no_advanced': '无文件或存储；30 天记录；每位用户 1 台设备',
  'plans.foundation.title': 'FOUNDATION',
  'plans.foundation.subtitle': 'Founder 计划',
  'plans.foundation.features.contacts': '与 PRO 相同的高级合约（每位用户最多 100 个联系人）',
  'plans.foundation.features.conversations': '租户内会话与聊天不限；与 PRO 相同限制',
  'plans.foundation.features.badge': 'Founder 计划（150 个编号名额）',
  'plans.foundation.features.support': '有 Founder 名额时每月 USD 15',
  'plans.pro.title': 'PRO',
  'plans.pro.subtitle': 'Pro 计划',
  'plans.pro.features.contacts': '每位用户最多 100 个联系人',
  'plans.pro.features.conversations': '租户内会话与聊天不限；1667 条/天、5 万条/月',
  'plans.pro.features.export': '租户最多 50 MB；导出、自动翻译与文件按方案',
  'plans.pro.features.notifications': '每位用户最多 3 台设备；租户邀请不限',
  'plans.actions.free': '当前计划',
  'plans.actions.foundation': '成为 Founder',
  'plans.actions.pro': '升级到 PRO',
  'plans.badges.recommended': '推荐',
  'plans.badges.limited': '限量',
  'plans.payments_disabled.title': '订阅',
  'plans.payments_disabled.message': '订阅正在逐步开放中。您可以查看可用套餐及其权益。',
  'plans.payments_disabled.confirm': '确定',
};